import { ColumnSettings, MasterTableSettings } from "@zing/grid";

export const hcColumnSettings: ColumnSettings[] = [
  {
    name: 'name',
    sort: false,
    order: 0,
    label: 'Name',
    width: 100
  },
  {
    name: 'message',
    sort: false,
    order: 1,
    label: 'Message',
    width: 200
  },
  {
    name: 'elapsed',
    sort: false,
    order: 2,
    label: 'Elapsed',
    width: 50
  },
  {
    name: 'status',
    sort: false,
    order: 3,
    label: 'Status',
    width: 50
  }
];

export const hcColumnSettingsAppraisals: ColumnSettings[] = [
  ...hcColumnSettings,
  {
    name: 'quota',
    sort: false,
    order: 4,
    label: 'Quota',
    width: 50
  }
]

export const hcMasterSettings: MasterTableSettings = {
  scrollable: false,
  showCurrentPageReport: false,
  displayPagination: false
};
